import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box, ModalBody, Text } from '@chakra-ui/react';
import { Area } from '@whitbread-eos/api';
import { formatNextLocaleLink } from '@whitbread-eos/utils';
import { useRouter } from 'next/router';
import HeaderSideNav from '../HeaderSideNav';
import NavigationItem from '../NavigationItem';
import { containerItemStyle } from '../NavigationMenuMobile.style';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export default function LanguageSelectorSideNav(_ref) {
  var currentLanguage = _ref.currentLanguage,
    languagesList = _ref.languagesList,
    onClickHeaderTitle = _ref.onClickHeaderTitle,
    tickIcon = _ref.tickIcon,
    _ref$area = _ref.area,
    area = _ref$area === void 0 ? Area.PI : _ref$area,
    labels = _ref.labels;
  var router = useRouter();
  var path = router === null || router === void 0 ? void 0 : router.asPath;
  return _jsxs(_Fragment, {
    children: [_jsx(HeaderSideNav, {
      title: labels.language,
      onClickTitle: onClickHeaderTitle
    }), _jsx(ModalBody, {
      p: "0",
      "data-testid": "languageSelectorSideNav",
      children: languagesList.map(language => {
        var link = formatNextLocaleLink(path, language.locale, currentLanguage, area);
        return _jsx(Box, {
          onClick: () => {
            window.location = link;
          },
          children: renderLanguageItem({
            languagesList: languagesList !== null && languagesList !== void 0 ? languagesList : [],
            fontWeight: currentLanguage === language.locale ? 'medium' : '',
            locale: language.locale,
            icon: currentLanguage == language.locale && tickIcon
          })
        }, language.locale);
      })
    })]
  });
}
export function renderLanguageItem(_ref2) {
  var languagesList = _ref2.languagesList,
    _ref2$locale = _ref2.locale,
    locale = _ref2$locale === void 0 ? '' : _ref2$locale,
    fontWeight = _ref2.fontWeight,
    icon = _ref2.icon,
    _ref2$withStyleHover = _ref2.withStyleHover,
    withStyleHover = _ref2$withStyleHover === void 0 ? false : _ref2$withStyleHover;
  return _jsx(Box, _objectSpread(_objectSpread({}, customContainerItemStyle), {}, {
    _hover: {
      color: withStyleHover && 'primary'
    },
    children: _jsx(NavigationItem, {
      title: _jsxs(_Fragment, {
        children: [renderFlag(locale, languagesList), _jsx(Box, {
          pl: "sm",
          children: _jsx(Text, {
            fontWeight: fontWeight,
            color: "darkGrey1",
            mb: 0,
            children: findLanguageName(locale, languagesList)
          })
        })]
      }),
      icon: icon
    })
  }));
}
function renderFlag(language, languagesList) {
  var country = languagesList.find(languageObject => languageObject.locale == language);
  if (country) {
    return country.icon;
  }
}
function findLanguageName(language, languagesList) {
  var country = languagesList.find(languageObject => languageObject.locale == language);
  if (country) {
    return country.languageName;
  }
}
var customContainerItemStyle = _objectSpread(_objectSpread({}, containerItemStyle), {}, {
  ml: 0,
  w: '100%',
  pl: 'md',
  cursor: 'pointer'
});